import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { post, get, getForUrlWithAuth } from "../../api";
import { page_limit_wishlist } from "utils";

const { USER_FAVORITE, USER_FAVORITES } = Routes;

/*******************
@purpose :  add user favorite data
@Parameter : {data}
@Author : INIC
******************/
export const addUserFavorite = (data) => async () => {
  const res = await post(`${USER_FAVORITE}`, true, data);
  if (res) {
    return res;
  }
  return Promise.reject(res);
};

/*******************
@purpose :  get user favorite details
@Parameter : {}
@Author : INIC
******************/
export const getUserFavorite =
  (loader = true) =>
  async (dispatch) => {
    try {
      let res = await get(
        `${USER_FAVORITES}?page_limit=${page_limit_wishlist}`,
        true,
        loader
      );
      dispatch(clearUserFavorite());
      dispatch(setUserFavorite(res));
      return Promise.resolve(res?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };

/*******************
@purpose :  Get load more data
@Parameter : {url}
@Author : INIC
******************/
export const getLoadMoreWishData = (url) => (dispatch) => {
  return getForUrlWithAuth(
    `${url}&page_limit=${page_limit_wishlist}`,
    false,
    true
  ).then((res) => {
    if (res?.data) {
      dispatch(setUserFavorite(res));
      return Promise.resolve(res);
    }
    return Promise.reject(res);
  });
};

/*******************
@purpose :  set user favorite data
@Parameter : {userFavdata}
@Author : INIC
******************/
export const setUserFavorite = (userFavData) => {
  return {
    type: types.USER_FAVORITE_DATA,
    data: userFavData,
  };
};

/*******************
@purpose :  clear user favorite data
@Parameter : {}
@Author : INIC
******************/
export const clearUserFavorite = () => {
  return {
    type: types.CLEAR_USER_FAVORITE_DATA,
    data: "",
  };
};
